export default {
  title: "Реестр Союза писателей",
  subtitle: "Публичные профили членов Союза.",
  empty: "Пока нет публичных профилей.",
  searchPlaceholder: "Поиск по имени или псевдониму",
  searchEmpty: "По запросу ничего не найдено.",
  portfolio: "Портфолио",
  portfolioEmpty: "Нет подтверждённых работ в портфолио.",
  notFound: "Писатель не найден.",
  back: "К реестру",
  openCatalog: "Карточка в каталоге НБР",
}
